// CashPaymentsRefunds.js
// Screen similar to ActiveOrders.js with two channels: New (cash payments) & Refunds
// Polls (or locally loads) one source that contains both sets. No optional chaining used.

import React, { Component } from "react";
import { Col, Row, Container, Button, Modal, Input } from "reactstrap";
import moment from "moment";


import OrderCashCard from "../../components/OrderCard/OrderCashCard";
import DetailedCashOrderCard from "../../components/DetailedOrderCard/DetailedCashOrderCard";
import ErrorTokenMiss from "../../components/ErrorTokenMiss/ErrorTokenMiss";

import RequestManager from "../../singletons/RequestManager";
import config from "../../config";
import {
  TIME_INTERVAL_ORDER,
  SDK_NGX_ASHWA,
  SDK_SUNMI_MINI_T1,
  SDK_SUNMI_PRO2,
  SDK_NGX_NIX,
  SDK_CHROME_ELECTRON,
} from "../../config/Constants";
import {
  generateEpochTimestamp,
  generateSignature,
} from "../../utils/helper";


function get(obj, path, defVal) {
  try {
    var parts = String(path).split(".");
    var cur = obj;
    for (var i = 0; i < parts.length; i++) {
      if (cur == null) return defVal;
      cur = cur[parts[i]];
    }
    return cur == null ? defVal : cur;
  } catch (e) {
    return defVal;
  }
}

let requestManager = new RequestManager();
let player = null;

export default class CashPaymentsRefunds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeInformation: null,
      loginMode: null,
      printinvoice:null,

      // data buckets
      newOrders: { edges: [] },
      refundOrders: { edges: [] },
      newCount: 0,
      refundCount: 0,

      // UI state
      orderModalVisible: false,
      popUpOrderDetails: null,
      tokenMissmatchModalVisible: false,
      tokenErrorMessage: "",

      // sound
      soundEnabled: false,

      // local filters
      filterToken: "",
      filterOrderId: "",
    };
  }

  componentDidMount() {
    var self = this;
    var events = ["click", "keydown", "mousemove", "touchstart"]; 
    events.forEach(function(e){ document.addEventListener(e, self.enableSoundNotifications, { once: true }); });

    this.getStoreDetails();
  }

  componentWillUnmount() {
    clearInterval(this.fetchOrderInterval);
    var self = this;
    var events = ["click", "keydown", "mousemove", "touchstart"]; 
    events.forEach(function(e){ document.removeEventListener(e, self.enableSoundNotifications); });
  }

  enableSoundNotifications = () => {
    if (!this.state.soundEnabled) {
      this.setState({ soundEnabled: true });
    }
  };

  getStoreDetails = async () => {
    // Keep parity with original flow but avoid optional chaining
    try {
      var response = await requestManager.getResponseFromPredefinedQuery("getUserProfile", {});
      console.log('response', response);
      if (response && !response.error && get(response, "data.userProfile.user.store", null)) {
        var storeInfoLocalRaw = localStorage.getItem("storeInformation");
        var storeInfoLocal = storeInfoLocalRaw ? JSON.parse(storeInfoLocalRaw) : {};
        var merged = {
          user: get(storeInfoLocal, "user", null),
          user_details:get(response,"data.userProfile.user.id",null),
          store: get(response, "data.userProfile.user.store", null),
          merchant: get(response, "data.userProfile.user.merchant", null),
          concessionaire: get(response, "data.userProfile.user.concessionaire", null),
          token: get(storeInfoLocal, "token", null),
        };
        localStorage.setItem("storeInformation", JSON.stringify(merged));

        var loginModeRaw = localStorage.getItem("loginMode");
        var printSdkType = get(merged, "store.printSdkType", null);
        if (printSdkType && printSdkType !== SDK_NGX_ASHWA && printSdkType !== SDK_SUNMI_MINI_T1 && printSdkType !== SDK_SUNMI_PRO2) {
          player = document.getElementById("audio");
        }

        this.setState({ loginMode: loginModeRaw, storeInformation: merged });

        // Start polling (still set up, though we'll serve local JSON in fetchOrders)
        this.fetchOrderInterval = setInterval(this.fetchOrders, TIME_INTERVAL_ORDER);
        this.fetchOrders();
      } else {
        // If profile unavailable, still try to render with local JSON
        this.fetchOrders();
      }
    } catch (e) {
      this.fetchOrders();
    }
  };


 getCashReceipt = async (order_id) => {
  
      
      let params = {};
      let loginMode = localStorage.getItem("loginMode");
        
        try {
            let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
            let authToken = storeInformation.token;
            let user_id = storeInformation.user_details;
            var vtimestamp = generateEpochTimestamp();
            let response = await fetch(
            config.getHost() + "/order/getcashorderreceipt/",
            {
                method: "POST",
                headers: {
                Authorization: `Token ${authToken}`,
                "Content-Type": "application/json",
                Timestamp: vtimestamp,
                Signature: generateSignature(vtimestamp, authToken),
                },
                body: JSON.stringify({
                //store_id: storeInformation.store && storeInformation.store.id,
                //graphql: true,
                "order_id":order_id
                }),
            }
            );

            if (response.status === 200) {
            let result = await response.json();
            //  console.log("Response", response);
            if (result.SUCCESS) {
                let data = result.data;
                this.setState({printinvoice:data})
                console.log("recepit",data);
                }
            } 
            else {
            console.log("res", response.status);
            }
        }   
        catch (error) {
              console.log("error", error);
            }
    
          }
        



  updateCashOrders = async (order_id,status, tendered_amount, changed_tendered ) => {
  
      
      let params = {};
      let loginMode = localStorage.getItem("loginMode");
        
        try {
            let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
            let authToken = storeInformation.token;
            let user_id = storeInformation.user_details;
            var vtimestamp = generateEpochTimestamp();
            let response = await fetch(
            config.getHost() + "/order/updatecashorder/",
            {
                method: "POST",
                headers: {
                Authorization: `Token ${authToken}`,
                "Content-Type": "application/json",
                Timestamp: vtimestamp,
                Signature: generateSignature(vtimestamp, authToken),
                },
                body: JSON.stringify({
                //store_id: storeInformation.store && storeInformation.store.id,
                //graphql: true,
                "order_id":order_id,
                "cashier":user_id,
                "graphql":true,
                "status":status,
                "tendered_amount":tendered_amount,
                "changed_tendered":changed_tendered
                
                }),
            }
            );

            if (response.status === 200) {
            let result = await response.json();
            //  console.log("Response", response);
            if (result.SUCCESS) {
                let data = result.data;
                this.setState({printinvoice:data})
                console.log("recepit",data);
                }
            } 
            else {
            console.log("res", response.status);
            }
        }   
        catch (error) {
              console.log("error", error);
            }
    
          }
        



  fetchOrders = async () => {
      
      let params = {};
      let loginMode = localStorage.getItem("loginMode");
        
        try {
            let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
            let authToken = storeInformation.token;
            var vtimestamp = generateEpochTimestamp();
            let response = await fetch(
            config.getHost() + "/order/getorders/",
            {
                method: "POST",
                headers: {
                Authorization: `Token ${authToken}`,
                "Content-Type": "application/json",
                Timestamp: vtimestamp,
                Signature: generateSignature(vtimestamp, authToken),
                },
                body: JSON.stringify({
                store_id: storeInformation.store && storeInformation.store.id,
                graphql: true,
                }),
            }
            );

            // console.log("Response", response);

            if (response.status === 200) {
            let result = await response.json();
            console.log("Response", result);
            if (result.SUCCESS) {
                let data = result.data;
                // console.log("Order Count:", data);
                        
                    // Safely pull arrays (no optional chaining)
                var cashpaymentsObj   = (data && data.cashpaymentsOrders) ? data.cashpaymentsOrders : { edges: [], totalCount: 0 };
                var cashrefundsObj    = (data && data.cashrefundsOrders)  ? data.cashrefundsOrders  : { edges: [], totalCount: 0 };

                // Edges already split by type in the new structure
                var newCashEdges = Array.isArray(cashpaymentsObj.edges) ? cashpaymentsObj.edges : [];
                var refundEdges  = Array.isArray(cashrefundsObj.edges)  ? cashrefundsObj.edges  : [];

                // If you want to trust file totals, use those; else compute from edges length
                var newCount    = typeof cashpaymentsObj.totalCount === "number" ? cashpaymentsObj.totalCount : newCashEdges.length;
                var refundCount = typeof cashrefundsObj.totalCount  === "number" ? cashrefundsObj.totalCount  : refundEdges.length;

                      this.setState(
      {
        newOrders:   { edges: newCashEdges },
        refundOrders:{ edges: refundEdges  },
        newCount:    newCount,
        refundCount: refundCount,
      },this.maybeNotify);
                 
                
                }
            } 
            else {
            console.log("res", response.status);
            }
        }   
        catch (error) {
              console.log("error", error);
            }
    
          }
        
      

  maybeNotify = () => {
    var newCount = this.state.newCount;
    try {
      if (newCount > 0 && typeof Notification !== "undefined" && Notification && Notification.permission === "granted") {
        new Notification("New Cash Order!", { body: "You have new cash payment orders to review." });
        this.playSound();
      }
    } catch (e) { /* ignore */ }
  };

  playSound = () => {
    if (player && this.state.soundEnabled) {
      try {
        var sound = (requestManager.getSoundFile && requestManager.getSoundFile()) || "bell";
        player.src = require("../../assets/sounds/" + sound + ".mp3");
        player.load();
        player.play();
      } catch (_) { /* ignore */ }
    }
  };

  cardSelected = () => {
    try {
      var storeInformationRaw = localStorage.getItem("storeInformation");
      var storeInformation = storeInformationRaw ? JSON.parse(storeInformationRaw) : {};
      var sdk = get(storeInformation, "store.printSdkType", null);
      if (sdk === SDK_NGX_ASHWA || sdk === SDK_SUNMI_MINI_T1 || sdk === SDK_SUNMI_PRO2) {
        if (window && window.totDevice) window.totDevice.postMessage("stop");
      } else if (player) {
        player.pause();
      }
    } catch (e) { /* ignore */ }
  };

  openOrderModal = (orderEdge) => {
    // Map incoming node shape (from local JSON) to DetailedOrderCard expected fields
    var node = (orderEdge && orderEdge.node) ? orderEdge.node : (orderEdge || {});
    var ordertype = String(node.ordertype || '').toLowerCase();

    if (ordertype === 'cashpayment') {
      var mappedCash = {
        masterOrderId: String(node.orderId || node.order_id || ''),
        totalAmount: Number(node.total || 0),
        foodCourtId: String(node.foodCourtId || ''),
        token: String(node.storeToken || ''),
        mode: 'Cash',
        status:String(node.status),
      };
      this.setState({ orderModalVisible: true, popUpOrderDetails: { node: mappedCash, __variant: 'cash' } });
      return;
    }

    // refund variant
    var mappedRefund = {
      masterOrderId: String(node.masterOrderId || ''),
      // foodCourtId: String(node.foodCourtId || ''),
      token: String(node.storeToken || ''),
      subOrderId: String(node.order_id || node.order_id || ''),
      refundAmount: (node.refundamount != null ? Number(node.refundamount) : (node.total != null ? Number(node.total) : NaN)),
      storeId: String(node.storeId || ''),
      storeName: String(node.storeName || ''),
       status:String(node.status),
    };
    this.setState({ orderModalVisible: true, popUpOrderDetails: { node: mappedRefund, __variant: 'refund' } });
  };

  closeOrderModal = () => {
    this.setState({ orderModalVisible: false, popUpOrderDetails: null });
  };


  printInvoiceRest = async (message) => {
    try {
      var jsonInvoiceBody = "";
      
     // const chromePrintersObject = JSON.parse(this.state.chromePrinters);
      const chromePrintersObject = typeof this.state.chromePrinters === "string"
    ? JSON.parse(this.state.chromePrinters)
    : this.state.chromePrinters;
      
          // Check if pageSize exists
    
      if(this.state.forcePrinterSelection && chromePrintersObject.INVOICEPRINTER && (Array.isArray(chromePrintersObject.INVOICEPRINTER)) && chromePrintersObject.INVOICEPRINTER.length > 0)
      {
        if(chromePrintersObject.pageSize){
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message,
            INVOICEPRINTER: chromePrintersObject.INVOICEPRINTER,
            pageSize: chromePrintersObject.pageSize
          })
        }else{
        jsonInvoiceBody = JSON.stringify({
          gnginvoiceprint: message,
          INVOICEPRINTER: chromePrintersObject.INVOICEPRINTER
        })
      }
      }
      else if(this.state.forcePrinterSelection && chromePrintersObject.KOTPRINTER && (Array.isArray(chromePrintersObject.KOTPRINTER)) && chromePrintersObject.KOTPRINTER.length > 0)
        {
          if(chromePrintersObject.pageSize){
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message,
            INNOVICEPRINTER: chromePrintersObject.KOTPRINTER,
            pageSize: chromePrintersObject.pageSize
          })
        }else{
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message,
            INNOVICEPRINTER: chromePrintersObject.KOTPRINTER
          })
        }
        }
        else
        {
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message
          })
        }
      console.log("Json Invoice body", jsonInvoiceBody);
      
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getPrinter(),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body:jsonInvoiceBody
       
          
        }
      );

      console.log("print", response);

      if (response.status !== 200) {
        if (response.status === 801){
          alert("printer Issue, Retry Print");  
        }
        else{
          alert("Printer Not Avaiable");
        }
      }
    } catch (error) {
      console.log("error", error);
      alert("Printer Not Avaiable");
    }
  };

  renderList = (edges) => {
    var filterToken = this.state.filterToken;
    var filterOrderId = this.state.filterOrderId;
    var self = this;
    return edges
      .filter(function(order){
        var n = order.node || {};
        var token = n.token || n.storeToken || '';
        var oid = n.orderId || n.order_id || n.id || '';
        return (
          (!filterToken || String(token).indexOf(filterToken) !== -1) &&
          (!filterOrderId || String(oid).indexOf(filterOrderId) !== -1)
        );
      })
      .map(function(order){
        var keyVal = (order.node && (order.node.orderId || order.node.order_id || order.node.id)) || Math.random();
        return (
          <OrderCashCard
      order={order}
      key={
        (order.node && (order.node.orderId || order.node.order_id || order.node.id)) ||
        Math.random()
      }
      onClick={() => { self.cardSelected(); self.openOrderModal(order); }}
    />
        );
      });
  };

  render() {
    var newOrders = this.state.newOrders;
    var refundOrders = this.state.refundOrders;
    var newCount = this.state.newCount;
    var refundCount = this.state.refundCount;
    var filterToken = this.state.filterToken;
    var filterOrderId = this.state.filterOrderId;

    var storeInformationRaw = localStorage.getItem("storeInformation");
    var storeInformation = storeInformationRaw ? JSON.parse(storeInformationRaw) : {};

    var printSdkType = get(storeInformation, 'store.printSdkType', null);

    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        {(get(storeInformation, 'store', null) && printSdkType && printSdkType !== SDK_NGX_ASHWA && printSdkType !== SDK_SUNMI_MINI_T1 && printSdkType !== SDK_SUNMI_PRO2) ? (
          <iframe id="audio" title="sound" hidden src={require("../../assets/sounds/mute.mp3")} />
        ) : null}

        {/* Header */}
        <Row className="border-bottom" style={{ backgroundColor: "whitesmoke" }}>
          <Col xs="12" style={{ margin: 10, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h4 style={{ marginLeft: 10 }}>Cash Payments & Refunds</h4>
            <div style={{ display: "flex", gap: 16 }}>
              <h5 style={{ margin: 0 }}>New: {newCount}</h5>
              <h5 style={{ margin: 0 }}>Refunds: {refundCount}</h5>
              <Button onClick={() => { if (player) { if (this.state.soundEnabled) { try { player.pause(); } catch(e){} } } this.setState({ soundEnabled: !this.state.soundEnabled }); }}>
                {this.state.soundEnabled ? "Mute" : "Start Sound"}
              </Button>
            </div>
          </Col>
        </Row>

        {/* Filters */}
        <Row style={{ padding: "10px" }}>
          <Col md="6">
            <Input
              placeholder="Filter by Token"
              value={filterToken}
              onChange={(e) => this.setState({ filterToken: e.target.value })}
            />
          </Col>
          <Col md="6">
            <Input
              placeholder="Filter by Order ID"
              value={filterOrderId}
              onChange={(e) => this.setState({ filterOrderId: e.target.value })}
            />
          </Col>
        </Row>

        {/* Two channels (forced side-by-side) */}
        <div style={{ display: "flex", gap: 16, alignItems: "flex-start", justifyContent: "stretch", padding: "0 10px" }}>
          <div style={{ flex: 1, minWidth: 0, backgroundColor: "white", borderRadius: 8, border: "1px solid #eee" }}>
            <p className="text-center p-2 font-weight-bold" style={{ borderBottom: "1px solid #eee", marginBottom: 0 }}>New (Cash Payments)</p>
            <div style={{ padding: 10 }}>
              {newOrders ? this.renderList(newOrders.edges) : null}
            </div>
          </div>

          <div style={{ flex: 1, minWidth: 0, backgroundColor: "whitesmoke", borderRadius: 8, border: "1px solid #eee" }}>
            <p className="text-center p-2 font-weight-bold" style={{ borderBottom: "1px solid #eee", marginBottom: 0 }}>Refunds</p>
            <div style={{ padding: 10 }}>
              {refundOrders ? this.renderList(refundOrders.edges) : null}
            </div>
          </div>
        </div>

        {/* Order details modal */}
        <Modal size="lg" isOpen={this.state.orderModalVisible} toggle={this.closeOrderModal}>
          <DetailedCashOrderCard
            variant={(this.state.popUpOrderDetails && this.state.popUpOrderDetails.__variant) || undefined}
            order={this.state.popUpOrderDetails}
            goBack={this.closeOrderModal}



onRePrint={(payload) => {
  console.log('Paid clicked', payload);

  this.getCashReceipt(
    payload.order_id
  )
    .then(async (response) => {
      if (response && response.status === 200) {
        const result = await response.json();
        if (result && result.SUCCESS) {
          // store receipt payload (if your API returns it)
          this.setState({ printinvoice: result.data });
        }
      } 
    })
    // IMPORTANT: pass a function, don't invoke immediately
    .then(() => this.printInvoiceRest(this.state.printinvoice))

}}

onPaid={(payload) => {
  console.log('Paid clicked', payload);

  this.updateCashOrders(
    payload.orderId,
    'PAID',                    // force the status passed to the API
    payload.tendered_amount,   // keep your working field names
    payload.changed_tendered
  )
    .then(async (response) => {
      if (response && response.status === 200) {
        const result = await response.json();
        if (result && result.SUCCESS) {
          // store receipt payload (if your API returns it)
          this.setState({ printinvoice: result.data });

          // 🔑 flip the OPEN MODAL status so buttons update immediately
          this.setState((prev) => {
            const details = prev.popUpOrderDetails;
            if (!details || !details.node) return null;
            const updated = {
              ...details,
              node: { ...details.node, status: 'PAID' },
            };
            return { popUpOrderDetails: updated };
          });
        }
      } else {
        // optional: still flip locally even if not 200
        this.setState((prev) => {
          const details = prev.popUpOrderDetails;
          if (!details || !details.node) return null;
          const updated = {
            ...details,
            node: { ...details.node, status: 'PAID' },
          };
          return { popUpOrderDetails: updated };
        });
      }
    })
    // IMPORTANT: pass a function, don't invoke immediately
    .then(() => this.printInvoiceRest(this.state.printinvoice))
    .finally(() => {
      this.fetchOrders();
      // keep the modal open so user can tap Receipt; or close if you prefer:
      // this.closeOrderModal();
    });

  if (typeof this.fetchOrders === 'function') this.fetchOrders();
}}


onRefunded={(payload) => {
  console.log('Refunded clicked', payload);

  if (typeof this.fetchOrders === 'function') this.fetchOrders();

  this.updateCashOrders(payload.orderId, 'REFUNDED', 0, 0)
    .then(async (response) => {
      if (response && response.status === 200) {
        const result = await response.json();
        if (result && result.SUCCESS) {
          // Save receipt payload (your existing behavior)
          this.setState({ printinvoice: result.data });

          // 🔑 Flip the status in the OPEN MODAL so buttons update immediately
          this.setState((prev) => {
            const details = prev.popUpOrderDetails;
            if (!details || !details.node) return null;
            const updated = {
              ...details,
              node: { ...details.node, status: 'REFUNDED' }, // <- key line
            };
            return { popUpOrderDetails: updated };
          });
        }
      } else {
        // If server didn't return 200, you can still flip locally (optional):
        this.setState((prev) => {
          const details = prev.popUpOrderDetails;
          if (!details || !details.node) return null;
          const updated = {
            ...details,
            node: { ...details.node, status: 'REFUNDED' },
          };
          return { popUpOrderDetails: updated };
        });
      }
    })
    // 👇 pass a function to then, do not call it immediately
    .then(() => this.printInvoiceRest(this.state.printinvoice))
    .finally(() => {
      this.fetchOrders(); 
      // keep open so Receipt is visible; or close if you prefer:
      // this.closeOrderModal();
    });
}}
     
          />
        </Modal>

        {/* Token error modal (kept for parity) */}
        <Modal size="lg" isOpen={this.state.tokenMissmatchModalVisible} toggle={() => this.setState({ tokenMissmatchModalVisible: false })}>
          <ErrorTokenMiss editable={true} tokenErrorMessage={this.state.tokenErrorMessage} goBack={() => this.setState({ tokenMissmatchModalVisible: false })} />
        </Modal>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ActiveOrders/ActiveCashOrders.js